export default __webpack_public_path__ + "old_performance_view.png";